module.exports = __webpack_public_path__ + "static/media/h-slider-1.e60ce1cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h-slider-1.jpg
// module id = 1144
// module chunks = 33